<template>
  <div>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <Table :options="options" :totalPages="fullInfoPayments.totalPages" />
    <Pagination :data="fullInfoPayments" :getQuery="getPayments" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import PaymentApi from '@/api/Payment/api'
import {ListOfPaymentsTable, ListOfPaymentsTableColumns} from '@/constants/TablesOptions/ListOfPaymentsTable'
import _ from 'lodash'
import InvoicesApi from '@/api/Invoce/api'
import Pagination from '@/components/Main/Pagination/Pagination'
import scrollTo from '@/mixin/scrollTo'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'ListOfPayments',
  mixins: [scrollTo],
  components: {
    Table,
    Pagination,
    LoaderFly
  },
  data () {
    return {
      options: ListOfPaymentsTable,
      defLimit: 30,
      fullInfoPayments: '',
      filterByDate: '',
      loaderRun: false
    }
  },
  computed: {
    listOfPaymentsTableColumns: {
      get: function () {
        return this.$store.getters.listOfPaymentsColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setListOfPaymentsColumnsData', data)
      }
    },
    listOfPaymentsRowsData: {
      get: function () {
        return this.$store.getters.listOfPaymentsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setListOfPaymentsRowsData', data)
      }
    }
  },
  methods: {
    addActions () {
      _.forEach(this.listOfPaymentsTableColumns, item => {
        if (item.actions) {
          item.actions.edit = this.editPayment
          item.actions.delete = this.delPayment
        }
      })
    },
    scrollUp () {
      const childrenRefs = _.find(this.$children, '$refs')
      const tableScroll = _.get(childrenRefs, '$refs.bbTableScroll.$el', false)
      if (!tableScroll) return
      tableScroll.scrollTop = 0
    },
    getPayments ({limit, page, filter}) {
      if (filter) {
        this.filterByDate = `paymentDate=${filter}`
      }
      this.loaderRun = true
      PaymentApi.getPayments({limit, page, filter: this.filterByDate})
        .then((resp) => {
          this.loaderRun = false
          this.fullInfoPayments = resp.data
          this.listOfPaymentsRowsData = resp.data.payments
          this.listOfPaymentsRowsData.forEach(item => {
            const allServices = _.get(item, 'invoice.services', [])
            const expiredServices = _.filter(allServices, item => item.expireCategory)
            const sumExpiredServices = _.sumBy(expiredServices, 'currentValue')
            const isOverpaid = _.get(item.invoice, 'isOverpaid', false)
            const isApproved = item.isApproved
            const noUpdateExpire = item.amountReceived <= sumExpiredServices
            if (isOverpaid || isApproved || noUpdateExpire) {
              item.static = true
            } else if (sumExpiredServices > 0) {
              item.minValue = _.round(sumExpiredServices, 2)
              item.minValueWith = 'amountReceived'
              item.noButton = {delete: true}
            }
          })
          this.addActions()
          this.scrollUp()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    editPayment (payment) {
      delete payment.paymentDate
      const index = _.findIndex(this.listOfPaymentsRowsData, {id: payment.id})
      PaymentApi.editPayment(payment, payment.id)
        .then((resp) => {
          this.listOfPaymentsRowsData[index].amountReceived = resp.data.amountReceived;
          this.addActions()
          this.getInvoicesTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    delPayment (id) {
      const index = _.findIndex(this.listOfPaymentsRowsData, {id: id})
      PaymentApi.delPayment(id)
        .then((resp) => {
          this.listOfPaymentsRowsData.splice(index, 1)
          this.getInvoicesTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getInvoicesTotal () {
      InvoicesApi.getInvoicesTotal({})
        .then((resp) => {
          this.$emit('setTotals', resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.$emit('setQuery', this.getPayments)
    this.getPayments({limit: this.defLimit})
    this.listOfPaymentsTableColumns = ListOfPaymentsTableColumns
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

</style>



// WEBPACK FOOTER //
// src/components/Finance/InvoiceTable/ListOfPayments/ListOfPayments.vue